import { TFunction } from 'i18next';
import { ConfirmOptions } from 'material-ui-confirm';

type ConfirmFn = (options: ConfirmOptions) => Promise<{ confirmed: boolean }>;

interface Params {
  confirm: ConfirmFn;
  t: TFunction;
  participantName: string;
  competitionName: string;
  distanceName: string;
  price?: number | null;
}

export async function confirmRegistrationCreate({
  confirm,
  t,
  participantName,
  competitionName,
  distanceName,
  price,
}: Params): Promise<boolean> {
  const description =
    price != null && !Number.isNaN(price)
      ? t('registrations.confirmCreateDescriptionWithPrice', {
          name: participantName,
          competition: competitionName,
          distance: distanceName,
          price: t('base.currencyValue', { count: price }),
        })
      : t('registrations.confirmCreateDescription', {
          name: participantName,
          competition: competitionName,
          distance: distanceName,
        });

  try {
    const { confirmed } = await confirm({
      title: t('registrations.confirmCreateTitle'),
      description,
      confirmationText: t('confirmProvider.confirmationText'),
      cancellationText: t('confirmProvider.cancellationText'),
    });
    return confirmed;
  } catch {
    return false;
  }
}
